//#region IMPORT
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import Icon from '../../../../Assets/Icon/CustomIcon';
import { Button } from '../../../../Components/MUIs';
import Commons from '../../../../Services/Common/Common';
import UserInfoCard from '../../../../Components/Ui/UserInfoCard';
import { Capacitor } from '@capacitor/core';
import { useSelector, useDispatch } from 'react-redux';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import BottomSheet from '../../../../Components/Ui/BottomSheet';
//#endregion

export default function M_TBG_CUSTOM_07(props) {
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);

  //#region 커스텀 UI
  const RecordControlButton = (onClick, icon, disabled) => (
    <IconButton
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '40px',
        color: '#FF6666',
        backgroundColor: '#fff',
        border: '2px solid #828282',
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {icon}
    </IconButton>
  );

  const PlayControlButton = (onClick, icon, disabled) => (
    <IconButton
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '40px',
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {icon}
    </IconButton>
  );
  //#endregion

  return (
    <Box sx={{ display: 'flex', gap: '16px', flexDirection: 'column', mx: 2 }}>
      <UserInfoCard
        progress={{ current: props.current, duration: props.duration }}
        profileImg={
          props.rowData.filter(
            (f) => f.ID === Commons.DecryptoAES(props.userInfo.userid)
          )[0]?.PROFILE
            ? props.rowData.filter(
              (f) => f.ID === Commons.DecryptoAES(props.userInfo.userid)
            )[0]?.PROFILE
            : ''
        }
        userInfo={props.userInfo}
        showConstruction={false}
        showProgress={false}
        showDayProgress={true}
        onClick={(e) => {
          dispatch(
            BottomSheetActions.SetBottomSheetState({
              bottom: true,
              type: 'profileDrawer',
            })
          );
        }}
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: '12px',
          border: '1px solid #EEEEEE',
          borderRadius: 4,
          py: '16px',
          backgroundColor: '#FFFFFF',
        }}
      >
        <Typography sx={{ pl: '16px', fontSize: '16px', fontWeight: '800' }}>
          추가 회의
        </Typography>
        {Capacitor.isNativePlatform() ? (
          <canvas
            ref={props.canvasRef}
            style={{ display: 'block', backgroundColor: '#F0F0F0' }}
          />
        ) : (
          <Box ref={props.waveformRef} sx={{ backgroundColor: '#F0F0F0' }} />
        )}
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {props.isRecording && (
            <Box
              sx={{
                position: 'absolute',
                left: '125px',
                transform: 'translateX(-50%)',
                borderRadius: '100%',
                width: '8px',
                height: '8px',
                backgroundColor: '#FF0000',
              }}
            />
          )}
          <Typography
            sx={{ textAlign: 'center', fontSize: '16px', fontWeight: '800' }}
          >
            {props.progress}
          </Typography>
        </Box>
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // gap: "5px",
          }}
        >
          {/* <Button onClick={togglePause} disabled={!props.isRecording}>
          {isPaused ? '다시 시작' : '일시정지'}
          </Button> */}
          {/* 재생 버튼 */}
          <Box
            sx={{
              position: 'absolute',
              left: 'calc(50% - 64px)', // ★ 녹음버튼(50%)에서 왼쪽으로 24px + 버튼 반너비(20px) 빼줌
              transform: 'translateX(-50%)',
            }}
          >
            {props.isPlaying
              ? PlayControlButton(
                props.PlayRecording,
                <Icon.Pause width="40px" height="40px" />,
                props.isRecording || !props.recordedFile
              )
              : PlayControlButton(
                props.PlayRecording,
                <Icon.Play width="40px" height="40px" />,
                props.isRecording || !props.recordedFile
              )}
          </Box>
          {/* 녹음 버튼 */}
          {props.isRecording
            ? RecordControlButton(
              props.StopRecording,
              <Icon.Stop width="40px" height="40px" />,
              props.isPlaying
            )
            : RecordControlButton(
              props.StartRecording,
              <Icon.Circle width="40px" height="40px" />,
              props.isPlaying
            )}
        </Box>
      </Box>
      {/* 파일 상태 표시 */}
      <Box sx={{ px: 2, mb: 1 }}>
        <Typography
          variant="caption"
          color={
            props.isRecording
              ? 'primary.main'
              : props.recordedFile
                ? 'success.main'
                : 'error.main'
          }
        >
          {props.isRecording
            ? '녹음 중...'
            : props.recordedFile
              ? `파일 준비됨: ${props.recordedFile.name} (${Math.round(
                props.recordedFile.size / 1024
              )}KB)`
              : '녹음 파일이 없습니다'}
        </Typography>
      </Box>
      <Button
        sx={{
          mb: 2,
          width: '100%',
          height: '36px',
          borderRadius: '18px',
        }}
        name="확인"
        onClick={() => props.SaveLogic1(props.recordedFile)}
        disabled={!props.recordedFile ? true : false}
      >
        확인
      </Button>
      {/* 프로필 바텀 드로워 */}
      {bottomSheetState.type === 'profileDrawer' && (
        <BottomSheet
          isHeaderChildren={true}
          headerText={''}
          headerChildren={
            <Typography
              sx={{ fontSize: '18px', fontWeight: 'bold', display: 'flex' }}
            >
              사용자 정보
            </Typography>
          }
        >
          <Box sx={{ p: '8px' }}>
            <Box sx={{ mb: 4 }}>
              <UserInfoCard
                profileImg={
                  props.rowData.filter(
                    (f) => f.id === Commons.DecryptoAES(props.userInfo.userid)
                  )[0]?.profile
                    ? props.rowData.filter(
                      (f) =>
                        f.id === Commons.DecryptoAES(props.userInfo.userid)
                    )[0]?.profile
                    : ''
                }
                userInfo={props.userInfo}
                showProgress={false}
                showButton={false}
                cardSx={{ p: 0, border: 0 }}
              />
            </Box>
            <Button
              sx={{
                width: '100%',
                height: '36px',
                borderRadius: '18px',
              }}
              name="확인"
              onClick={() => dispatch(BottomSheetActions.CloseBottomSheet())}
            />
          </Box>
        </BottomSheet>
      )}
    </Box>
  );
}
